var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h2',{staticClass:"mb-5"},[_vm._v("Add User Profile")]),_c('UserProfileForm',{on:{"createUserProfile":_vm.createUserProfile,"back":function($event){return _vm.$router.push({ name: 'MobileUserProfileIndex' })}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }